import React, { useEffect, useState } from "react";
import firebase from "firebase/app";
import "firebase/firestore";
import { Context } from "../backend/context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";
import { Redirect } from "react-router";
import BotDetails from "./botDetails";
import { Bar } from "react-chartjs-2";

import { connect } from "react-redux";

function Dashboard(props) {
  const {
    pendingBots,
    activeBots,
    stoppedBots,
    usersCount,
    exchangeData,
    closeBanner,
    isBannerDisplay,
    weeklyAccountBalances,
    isProUser,
    isProPlusUser,
    summery,
    total,
    isLoggedIn,
    maxBot,
    api_key,
    user,
    uid,
    setAlert,
    isRestricted,

    setIsRestricted,
  } = React.useContext(Context);

  const [chartType, setChartType] = useState(0);
  const [chartData, setChartData] = useState({
    labels: Object.keys(props.userWeeklydata),
    datasets: [
      {
        label: "Volume",
        backgroundColor: [
          "#181a1b",
          "#313335",
          "#181a1b",
          "#313335",
          "#181a1b",
          "#313335",
          "#181a1b",
        ],
        color: "red",
        borderColor: "black",
        borderWidth: 1,
        hoverBackgroundColor: "black",
        hoverBorderColor: "white",
        data: Object.keys(props.userWeeklydata).map(function (key) {
          return props.userWeeklydata[key].toFixed(2);
        }),
      },
    ],
  });

  useEffect(() => {
    if (activeBots.length + pendingBots.length >= maxBot) {
      setIsRestricted(true);
      setAlert(
        true,
        "You have reached the Max number of active and pending bots. Please stop running bots to create new bot.",
        "warning"
      );
    } else {
      setIsRestricted(false);
      setAlert(false, "", "warning");
    }
  }, [activeBots, pendingBots]);

  const stopActiveBot = (id, displayId) => {
    if (window.confirm(`Stop bot ${displayId} ?`)) {
      var docu = firebase.firestore().collection("bots").doc(id);
      docu.update({ isRunning: false });
    }
  };
  const startStoppedBot = (id, item) => {
    if (window.confirm(`Start bot ${item.displayId} ?`)) {
      var docu = firebase.firestore().collection("bots").doc(id);
      docu.update({ isPending: true });
      firebase
        .firestore()
        .collection("pendingBots")
        .doc(id)
        .set({ ...item, isPending: true })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const deleteStoppedBot = async (id, displayId) => {
    if (window.confirm(`Delete bot ${displayId} ?`)) {
      var docu = firebase.firestore().collection("bots").doc(id);
      docu.update({ isDeleted: true });
      // console.log(id);

      firebase.database().ref(`pendingOrders/${uid}/${id}`).remove();
      firebase.database().ref(`filledOrders/${uid}/${id}`).remove();
      firebase.database().ref(`cancelledOrders/${uid}/${id}`).remove();
      // console.log(id, "deleted");
    }
  };
  const handleDeleteALL = () => {
    if (window.confirm(`Delete All Stopped Bots ?`)) {
      stoppedBots.forEach((element) => {
        firebase
          .firestore()
          .collection("bots")
          .doc(element.id)
          .update({ isRunning: false, isDeleted: true });

        firebase.database().ref(`pendingOrders/${uid}/${element.id}`).remove();
        firebase.database().ref(`filledOrders/${uid}/${element.id}`).remove();
        firebase
          .database()
          .ref(`cancelledOrders/${uid}/${element.id}`)
          .remove();
        // console.log(element.id, "deleted");
      });
      // getBotData();
    }
  };
  const handleStartALL = () => {
    if (window.confirm(`Start All Stopped Bots ?`)) {
      var list =
        maxBot < stoppedBots.length + activeBots.length + pendingBots.length
          ? stoppedBots.slice(
              0,
              maxBot - (activeBots.length + pendingBots.length)
            )
          : stoppedBots;
      list.forEach((element) => {
        firebase
          .firestore()
          .collection("bots")
          .doc(element.id)
          .update({ isPending: true });

        firebase
          .firestore()
          .collection("pendingBots")
          .doc(element.id)
          .set({ ...element, isPending: true })
          .then((ref) => {
            // console.log("Bot successfully added");
          })
          .catch((err) => {
            console.log(err);
          });
      });
    }
  };
  const handleCancelPOnStopAll = () => {
    if (window.confirm(`Cancel Pending Orders and Stop All Bots ?`)) {
      activeBots.forEach((element) => {
        firebase
          .firestore()
          .collection("bots")
          .doc(element.id)
          .update({ cancelPendingOrders: true, isRunning: false });
      });
    }
  };

  const handleStopAll = () => {
    if (window.confirm(`Stop All Bots ?`)) {
      activeBots.forEach((element) => {
        firebase
          .firestore()
          .collection("bots")
          .doc(element.id)
          .update({ isRunning: false });
      });
    }
  };
  const getBotVolumeNprofit = (id) => {
    var x;
    var obj = {};
    for (x in props.volumeNprofitData) {
      // console.log(x);
      if (props.volumeNprofitData[x].key === id) {
        obj = props.volumeNprofitData[x];
        return props.volumeNprofitData[x];
      }
    }
    return obj;
  };

  const createACopyofBot = (bot) => {
    let data = {
      ...bot,
      name:
        "Copy of " +
        (bot.name && bot.name.length > 0 ? bot.name : bot.displayId),
      createdAt: Date.now(),
      uid: uid,
      isRunning: false,
      isDeleted: false,
      isPending: false,
      processID: "",
      displayId: (props.botsCount + 100000).toString(),
    };
    firebase
      .firestore()
      .collection("bots")
      .add(data)
      .then((ref) => {
        // console.log("New Bot successfully saved");
        var botsCountRef = firebase.database().ref("botsCount").push();

        botsCountRef.set({
          displayId: (props.botsCount + 100000).toString(),
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (chartType === 0) {
      setChartData({
        labels: Object.keys(props.userWeeklydata),

        datasets: [
          {
            label: "Volume",
            backgroundColor: [
              "#181a1b",
              "#313335",
              "#181a1b",
              "#313335",
              "#181a1b",
              "#313335",
              "#181a1b",
            ],
            color: "red",
            borderColor: "black",
            borderWidth: 1,
            hoverBackgroundColor: "black",
            hoverBorderColor: "white",
            data: Object.keys(props.userWeeklydata).map(function (key) {
              return props.userWeeklydata[key].toFixed(2);
            }),
          },
        ],
      });
    } else if (chartType === 1) {
      setChartData({
        labels: Object.keys(props.userWeeklyProfitdata),

        datasets: [
          {
            label: "Profit",
            backgroundColor: [
              "#181a1b",
              "#313335",
              "#181a1b",
              "#313335",
              "#181a1b",
              "#313335",
              "#181a1b",
            ],
            color: "red",
            borderColor: "black",
            borderWidth: 1,
            hoverBackgroundColor: "black",
            hoverBorderColor: "white",
            data: Object.keys(props.userWeeklyProfitdata).map(function (key) {
              return props.userWeeklyProfitdata[key].toFixed(2);
            }),
          },
        ],
      });
    } else {
      setChartData({
        labels: Object.keys(weeklyAccountBalances),

        datasets: [
          {
            label: "Balance",
            backgroundColor: [
              "#181a1b",
              "#313335",
              "#181a1b",
              "#313335",
              "#181a1b",
              "#313335",
              "#181a1b",
            ],
            color: "red",
            borderColor: "black",
            borderWidth: 1,
            hoverBackgroundColor: "black",
            hoverBorderColor: "white",
            data: Object.keys(weeklyAccountBalances).map(function (key) {
              return weeklyAccountBalances[key].toFixed(2);
            }),
          },
        ],
      });
    }
  }, [
    props.userWeeklyProfitdata,
    props.userWeeklydata,
    chartType,
    weeklyAccountBalances,
  ]);

  return (
    <div className="container-fluid py-5 badge-dark ">
      <div className="row">
        <div className="col-md-9">
          <div className="container text-left">
            {!isLoggedIn || !user ? <Redirect to="/" /> : null}
            {"8HcYdjoSgpdLzE4TOIT0iKjZRJk1" === uid && false && (
              <div className="row">
                <div className="col-6 mt-3 h5 text-left">
                  Total Users : {usersCount}
                </div>
                {/* <div className="col-6 mt-3 h5 text-left">
                  Total Bots : {botsCount}
                </div> */}
              </div>
            )}
            {true && (
              <div className="row mt-3 ">
                <div className="col-12 col-sm-8 m-auto">
                  <div className="row rounded-lg border-black border no-gutters">
                    <div
                      className=" col-12 text-left rounded-lg p-3"
                      style={{ backgroundColor: "#b30000" }}
                    >
                      <div className="row">
                        <div className="col-12 text-center">
                          <strong>
                            This platform is no longer maintained.
                          </strong>
                          <br />
                          Please switch to new platform{" "}
                          <strong>
                            <a target="_blank" href="https://coinner.co">
                              Coinner.co
                            </a>
                          </strong>{" "}
                          . <br /> Contact{" "}
                          <strong>
                            {" "}
                            <a
                              target="_blank"
                              href="https://t.me/CoinnerOfficial"
                            >
                              here
                            </a>
                          </strong>{" "}
                          for more info.
                        </div>{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {false && ( //!(isProUser || isProPlusUser)
              <div className="row mt-3 ">
                <div className="col-12 col-sm-8 m-auto">
                  <div className="row rounded-lg border-black border no-gutters">
                    {false && (
                      <button
                        onClick={closeBanner}
                        style={{
                          border: "none",
                          background: "none",
                          color: "white",
                          position: "absolute",
                          top: "1px",
                          right: "16px",
                          backgroundColor: "black",
                          // width: "25px",
                          // height: "25px",
                          paddingLeft: "0.5rem",
                          paddingRight: "0.5rem",
                          paddingBottom: "0.1rem",
                          zIndex: "1000",
                        }}
                      >
                        x
                      </button>
                    )}
                    <div className=" col-12 col-sm-9 text-left rounded-lg">
                      <img
                        className="img-fluid "
                        src="/img/promoN.jpg"
                        alt="nash"
                        style={{ maxHeight: "150px" }}
                      />
                    </div>

                    <div className="col-12 col-sm-3 m-auto p-2 text-center">
                      <a
                        className="btn btn-primary w-75 m-auto"
                        target="_blank"
                        href="https://app.nash.io/trade/league/squad/3f776294-7c6c-4ddf-a393-83ece867d48e?code=2ty1Z4"
                      >
                        Join Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="row mt-3 ">
              <div className="col-sm-4 col-6 m-auto text-center">
                <Link
                  to="/account/leaderboard"
                  className="btn btn-dark w-100"
                  style={{ backgroundColor: "black" }}
                >
                  Leaderboard
                </Link>
              </div>
              <div className="col-sm-4 col-6 m-auto text-center">
                <Link
                  to="/account/send-tip"
                  className="btn btn-success btn-sm w-100"
                >
                  Send a Tip
                </Link>
              </div>
            </div>
            <div
              className="row rounded-lg m-0 my-3 p-2 badge-secondary"
              style={{
                height: "100%",
              }}
            >
              <div className="col-5 text-center rounded-lg py-2  badge-dark m-auto">
                <div className="row text-center">
                  <div className="col-12 h6 px-1 text-success">
                    Today Profit
                  </div>
                </div>
                <div className="row text-center">
                  {props.todayProfit >= 0 ? (
                    <div className="col-12 h6 px-1 text-success">
                      ${props.todayProfit.toFixed(2)}{" "}
                      <small>
                        {props.todayProfit && props.todayVolume
                          ? (
                              (props.todayProfit * 100) /
                              props.todayVolume
                            ).toFixed(2)
                          : 0}
                        %
                      </small>
                    </div>
                  ) : (
                    <div className="col-12 h6 px-1 text-danger">
                      ${props.todayProfit.toFixed(2)}{" "}
                      <small>
                        {props.todayProfit && props.todayVolume
                          ? (
                              (-props.todayProfit * 100) /
                              props.todayVolume
                            ).toFixed(2)
                          : 0}
                        %
                      </small>{" "}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-5 offset-1 text-center rounded-lg py-2 badge-dark m-auto">
                <div className="row  text-center">
                  <div className="col-12 h6 px-1 text-light">Today Volume</div>
                </div>
                <div className="row text-center">
                  <div className="col-12 h6 px-1 text-light">
                    ${props.todayVolume.toFixed(2)}
                  </div>
                </div>
              </div>
            </div>
            {api_key.length < 10 && (
              <div className="row">
                <div className="col-12 alert alert-warning text-center">
                  API KEY NOT FOUND ! Please add your API KEY.
                  <Link to="/account/settings">Go To Settings</Link>
                </div>
              </div>
            )}
            <div className="row mt-3">
              <div className="col-7 h3">
                My Bots{" "}
                <small>
                  ({activeBots.length + pendingBots.length}/{maxBot})
                </small>
              </div>
              <div className="col-5 text-center">
                <Link
                  type="button"
                  disabled={api_key.length < 10}
                  className="btn btn-dark"
                  to={"/account/createBot"}
                  style={{ backgroundColor: "black", borderRadius: "20px" }}
                >
                  + New Bot
                </Link>
              </div>
            </div>
            <div className="row">
              <div className="col-3 mt-3 h5">Active Bots</div>

              <div className="col-6 mt-3 text-right">
                <button
                  type="button"
                  className="btn btn-danger  btn-sm  px-1"
                  onClick={handleCancelPOnStopAll}
                >
                  Cancel Pending Orders & Stop All
                </button>
              </div>
              <div className="col-3 mt-3 text-right">
                <button
                  type="button"
                  className="btn btn-danger  btn-sm px-1"
                  onClick={handleStopAll}
                >
                  Stop All
                </button>
              </div>
            </div>
            <div className="row">
              <div
                className="col-12 w-100 pb-3"
                style={{ overflowX: "scroll", overflowY: "hidden" }}
              >
                <div
                  className="row mt-1 bold text-center badge-secondary border-dark rounded-top rounded-lg
        border-bottom"
                  style={{ minWidth: "950px" }}
                >
                  <div className="col-4 m-auto">
                    <div className="row">
                      <div
                        className="col-3 py-2 px-1  border-dark verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Bot Name
                      </div>
                      <div
                        className="col-2 py-2 px-1 border-dark border-left verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Trend
                      </div>
                      <div
                        className="col-2 py-2 px-1 border-dark border-left verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Type
                      </div>
                      <div
                        className="col-3 py-2 px-1 border-dark border-left verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Market
                      </div>
                      <div
                        className="col-2 py-2 px-1 border-dark border-left verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Strategy
                      </div>
                    </div>
                  </div>{" "}
                  <div className="col-4 m-auto">
                    <div className="row">
                      <div
                        className="col-3 py-2 px-1  border-dark border-left verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Take Profit (%)
                      </div>
                      <div
                        className="col-3 py-2 px-1 border-dark border-left verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        StopLoss (%)
                      </div>
                      <div
                        className="col-3 py-2 px-1 border-dark border-left verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Pending Orders
                      </div>
                      <div
                        className="col-3 py-2 px-1 border-dark border-left verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Order Size
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="row">
                      <div
                        className="col-3 py-2 px-1 border-dark border-left verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Today Profit ($)
                      </div>
                      <div
                        className="col-4 py-2 px-1 border-dark border-left verticalCenter "
                        style={{ fontSize: "0.9rem" }}
                      >
                        Today Volume ($)
                      </div>
                      <div
                        className="col-2 py-2 px-1 border-dark border-left verticalCenter "
                        style={{ fontSize: "0.9rem" }}
                      >
                        Profit (%)
                      </div>
                      <div className="col-3 py-1 border-dark border-left   "></div>
                    </div>
                  </div>
                </div>
                <BotDetails
                  data={activeBots}
                  type="ACTIVE"
                  stopActiveBot={stopActiveBot}
                  createACopyofBot={createACopyofBot}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 mt-3 h5">Pending Bots</div>
            </div>
            <div className="row">
              <div className="col-12 w-100" style={{ overflowX: "scroll" }}>
                <div
                  style={{ minWidth: "950px" }}
                  className="row mt-1  bold text-center badge-secondary border-dark border-bottom rounded-top rounded-lg"
                >
                  <div className="col-4 m-auto">
                    <div className="row">
                      <div
                        className="col-3 py-2 px-1  border-dark   verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Bot Name
                      </div>
                      <div
                        className="col-3 py-2 px-1  border-dark border-left  verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Trend
                      </div>
                      <div
                        className="col-3 py-2 px-1 border-dark border-left  verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Type
                      </div>{" "}
                      <div
                        className="col-3 py-2 px-1 border-dark border-left  verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Market
                      </div>
                    </div>
                  </div>{" "}
                  <div className="col-4 m-auto">
                    <div className="row">
                      <div
                        className="col-3 py-2 px-1  border-dark border-left  verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Strategy
                      </div>
                      <div
                        className="col-3 py-2 px-1  border-dark border-left  verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Take Profit (%)
                      </div>
                      <div
                        className="col-3 py-2 px-1 border-dark border-left  verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        StopLoss (%)
                      </div>{" "}
                      <div
                        className="col-3 py-2 px-1 border-dark border-left  verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Order Size
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="row">
                      <div
                        className="col-3 py-2 px-1 border-dark border-left verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Today Profit ($)
                      </div>
                      <div
                        className="col-4 py-2 px-1 border-dark border-left  verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Today Volume ($)
                      </div>
                      <div
                        className="col-2 py-2 px-1 border-dark border-left  verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Profit (%)
                      </div>
                      <div
                        className="col-3 py-2 px-1 border-dark border-left "
                        style={{ fontSize: "0.9rem" }}
                      ></div>
                    </div>
                  </div>
                </div>
                {pendingBots.length > 0 ? (
                  pendingBots.map((item, key) => {
                    var volumeNprofit = getBotVolumeNprofit(item.id);
                    return (
                      <div
                        style={
                          item.type === "BUY"
                            ? { minWidth: "950px", backgroundColor: "#3d4142" }
                            : { minWidth: "950px", backgroundColor: "#252728" }
                        }
                        key={key}
                        className="row  text-center border-secondary border-bottom"
                      >
                        <div className="col-4">
                          <div className="row">
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2 px-1   border-secondary border-left  overflow-hidden text-truncate"
                            >
                              {item.name && item.name.length > 0
                                ? item.name
                                : item.displayId}
                            </div>
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2 px-1   border-secondary border-left  overflow-hidden"
                            >
                              {!(
                                item.strategy.name === "MARKET-MAKER" ||
                                item.strategy.name === "MARKET-MAKER-RSI" ||
                                item.strategy.name === "EMA-MA-CROSSOVER"
                              )
                                ? item.type
                                : "-"}
                            </div>
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2  overflow-hidden px-1 border-secondary border-left  text-uppercase"
                            >
                              {!(
                                item.strategy.name === "MARKET-MAKER" ||
                                item.strategy.name === "MARKET-MAKER-RSI" ||
                                item.strategy.name === "EMA-MA-CROSSOVER"
                              )
                                ? item.dcaOrGrid
                                : "-"}
                            </div>{" "}
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2  overflow-hidden px-1 border-secondary border-left  text-uppercase"
                            >
                              {item.market}
                            </div>
                          </div>
                        </div>{" "}
                        <div className="col-4">
                          <div className="row">
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2  overflow-hidden px-1 border-secondary border-left  text-uppercase"
                            >
                              {item.strategy.name
                                .match(/\b(\w)/g)
                                .join("")
                                .toUpperCase()}
                            </div>
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2 px-1   border-secondary border-left  overflow-hidden"
                            >
                              {item.takeProfit}
                            </div>
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2  overflow-hidden px-1 border-secondary border-left  text-uppercase"
                            >
                              {item.isStopLossSet ? item.stopLoss : "-"}
                            </div>{" "}
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2 px-1   border-secondary border-left  overflow-hidden"
                            >
                              {item.orderSize}
                            </div>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="row">
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2 px-1 border-secondary border-left "
                            >
                              {volumeNprofit.bottodayProfit
                                ? volumeNprofit.bottodayProfit.toFixed(2)
                                : 0}
                            </div>
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-4 py-2 px-1 border-secondary border-left "
                            >
                              {volumeNprofit.bottodayVolume &&
                                volumeNprofit.bottodayVolume.toFixed(2)}
                            </div>
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-2 py-2 px-1 border-secondary border-left "
                            >
                              {volumeNprofit.bottodayVolume
                                ? (
                                    (volumeNprofit.bottodayProfit /
                                      volumeNprofit.bottodayVolume) *
                                    100
                                  ).toFixed(2)
                                : 0}
                            </div>
                            <div className="col-3 py-1 border-secondary border-left  px-0  border-right">
                              <button
                                className="btn btn-danger btn-sm mx-0"
                                disabled
                              >
                                Stop
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{ minWidth: "950px" }}
                    className="row  text-center border-secondary border-bottom border-left   border-right "
                  >
                    <div className="col-12 text-center">No Pending Bots.</div>
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-5 pr-0 mr-0 mt-3 h5 ">Stopped Bots</div>

              <div className="col-7 mt-3 text-right">
                <button
                  disabled={isRestricted}
                  type="button"
                  className="btn btn-success btn-sm mr-2 px-1"
                  onClick={handleStartALL}
                >
                  Start All
                </button>
                <button
                  type="button"
                  className="btn btn-danger ml-2 btn-sm px-1"
                  onClick={handleDeleteALL}
                >
                  Delete All
                </button>
              </div>
            </div>
            <div className="row">
              <div
                className="col-12 w-100 pb-3"
                style={{ overflowX: "scroll", overflowY: "hidden" }}
              >
                <div
                  style={{ minWidth: "950px" }}
                  className="row mt-1  bold text-center badge-secondary border-dark border-bottom rounded-top rounded-lg"
                >
                  <div className="col-4 m-auto">
                    <div className="row ">
                      <div
                        className="col-3 py-2 px-1    verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Bot Name
                      </div>
                      <div
                        className="col-3 py-2 px-1 border-dark border-left  verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Trend
                      </div>
                      <div
                        className="col-3 py-2 px-1 border-dark border-left  verticalCenter "
                        style={{ fontSize: "0.9rem" }}
                      >
                        Type
                      </div>
                      <div
                        className="col-3 py-2 px-1 border-dark border-left  verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Market
                      </div>
                    </div>
                  </div>
                  <div className="col-4 m-auto">
                    <div className="row ">
                      <div
                        className="col-3 py-2 px-1 border-dark border-left    verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Strategy
                      </div>
                      <div
                        className="col-3 py-2 px-1 border-dark border-left  verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Take Profit (%)
                      </div>
                      <div
                        className="col-3 py-2 px-1 border-dark border-left  verticalCenter "
                        style={{ fontSize: "0.9rem" }}
                      >
                        StopLoss (%)
                      </div>
                      <div
                        className="col-3 py-2 px-1 border-dark border-left  verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Order Size
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="row">
                      <div
                        className="col-3 py-2 px-1 border-dark border-left  verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Today Profit ($)
                      </div>
                      <div
                        className="col-3 py-2 px-1 border-dark border-left  verticalCenter"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Today Volume
                      </div>
                      <div
                        className="col-3 py-2 px-1 border-dark border-left "
                        style={{ fontSize: "0.9rem" }}
                      ></div>
                      <div className="col-3 py-1 border-dark border-left   "></div>
                    </div>
                  </div>
                </div>
                {stoppedBots.length > 0 ? (
                  stoppedBots.map((item, key) => {
                    var volumeNprofit = getBotVolumeNprofit(item.id);
                    return (
                      <div
                        key={key}
                        style={
                          item.type === "BUY"
                            ? { minWidth: "950px", backgroundColor: "#3d4142" }
                            : { minWidth: "950px", backgroundColor: "#252728" }
                        }
                        className="row  text-center border-secondary border-bottom"
                      >
                        <div className="col-4">
                          <div className="row">
                            <div className="col-3 py-1 px-1   border-secondary  border-left tooltipMy">
                              <Link
                                type="button"
                                className="px-1 btn-dark w-100 py-1 text-truncate "
                                to={"/account/bot/" + item.id}
                                style={{
                                  borderRadius: "10px",
                                  fontSize: "0.9rem",
                                  color: "#bdc0c2",
                                  backgroundColor: "black",
                                }}
                              >
                                {item.name && item.name.length > 0
                                  ? item.name
                                  : item.displayId}
                              </Link>
                              <div
                                className="tooltiptextmy text-center"
                                style={{
                                  width: "9rem",
                                  marginLeft: "1rem",
                                  backgroundColor: "black",
                                }}
                              >
                                <span>
                                  {item.name && item.name.length > 0
                                    ? item.name
                                    : item.displayId}
                                  <br />
                                </span>
                                <button
                                  onClick={() => createACopyofBot(item)}
                                  type="button"
                                  className="btn btn-dark btn-sm mt-1"
                                >
                                  Create a Copy
                                </button>
                              </div>
                            </div>
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2 px-1  overflow-hidden border-secondary border-left  text-uppercase"
                            >
                              {!(
                                item.strategy.name === "MARKET-MAKER" ||
                                item.strategy.name === "MARKET-MAKER-RSI" ||
                                item.strategy.name === "EMA-MA-CROSSOVER"
                              )
                                ? item.type
                                : "-"}
                            </div>
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2 px-1  overflow-hidden border-secondary border-left  text-uppercase"
                            >
                              {!(
                                item.strategy.name === "MARKET-MAKER" ||
                                item.strategy.name === "MARKET-MAKER-RSI" ||
                                item.strategy.name === "EMA-MA-CROSSOVER"
                              )
                                ? item.dcaOrGrid
                                : "-"}
                            </div>
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2 px-1  overflow-hidden border-secondary border-left  text-uppercase"
                            >
                              {item.market}
                            </div>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="row">
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2 px-1   overflow-hidden border-secondary border-left "
                            >
                              {item.strategy.name
                                .match(/\b(\w)/g)
                                .join("")
                                .toUpperCase()}
                            </div>
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2 px-1  overflow-hidden border-secondary border-left  text-uppercase"
                            >
                              {item.takeProfit}
                            </div>
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2 px-1  overflow-hidden border-secondary border-left  text-uppercase"
                            >
                              {item.isStopLossSet ? item.stopLoss : "-"}
                            </div>
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2 px-1  overflow-hidden border-secondary border-left  text-uppercase"
                            >
                              {item.orderSize}
                            </div>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="row">
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2 px-1 border-secondary border-left "
                            >
                              {volumeNprofit.bottodayProfit
                                ? volumeNprofit.bottodayProfit.toFixed(2)
                                : 0}
                            </div>
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-2 px-1 border-secondary border-left "
                            >
                              {volumeNprofit.bottodayVolume &&
                                volumeNprofit.bottodayVolume.toFixed(2)}
                            </div>
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-1 border-secondary border-left   border-right px-0"
                            >
                              <button
                                disabled={isRestricted}
                                className="btn btn-success  mx-0 btn-sm"
                                onClick={() => {
                                  startStoppedBot(item.id, item);
                                }}
                              >
                                Start
                              </button>
                            </div>
                            <div
                              style={{
                                fontSize: "0.9rem",
                                color: "#bdc0c2",
                              }}
                              className="col-3 py-1 border-secondary   border-right px-0"
                            >
                              <button
                                className="btn btn-danger  mx-0 btn-sm"
                                onClick={() => {
                                  deleteStoppedBot(
                                    item.id,
                                    item.displayId,
                                    item.market
                                  );
                                }}
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{ minWidth: "950px" }}
                    className="row  text-center border-secondary border-bottom border-left   border-right "
                  >
                    <div className="col-12 text-center">No Stopped Bots.</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 my-3  ">
          <div className="row px-2">
            <div className="col-12 rounded-lg badge-dark border border-black  py-3 my-2">
              <div className="row">
                <div className="col-12 h6 ">
                  Monthly Volume :{"  "}
                  {props.monthlyVolume.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
                </div>
              </div>
              <div className="row">
                <div className="col-12 ">
                  Monthly Profit : ${props.monthlyProfit.toFixed(2)}{" "}
                </div>
              </div>
            </div>
          </div>
          <div className="row px-2">
            <div className="col-12 rounded-lg badge-dark border border-black  h5 py-3">
              <div className="row mb-2">
                <div className="col-10 h6">
                  Last 7 Day's{" "}
                  {chartType === 0
                    ? "Volume"
                    : chartType === 1
                    ? "Profit"
                    : "Account Balance"}
                </div>
                <div className="col-2 text-right ">
                  <button
                    className="btn btn-sm btn-dark pb-0"
                    style={{ backgroundColor: "black" }}
                    onClick={() =>
                      setChartType(chartType === 2 ? 0 : chartType + 1)
                    }
                  >
                    <FontAwesomeIcon
                      icon={faAngleRight}
                      size="2x"
                      color="white"
                    />
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <Bar
                    data={chartData}
                    width={100}
                    height={250}
                    options={{
                      maintainAspectRatio: false,
                      tooltips: {
                        fontColor: "#d7d9da",
                        callbacks: {
                          label: function (tooltipItem, chart) {
                            var datasetLabel =
                              chart.datasets[tooltipItem.datasetIndex].label ||
                              "";
                            return datasetLabel + ": $" + tooltipItem.yLabel;
                          },
                        },
                      },
                      scales: {
                        yAxes: [
                          {
                            ticks: {
                              beginAtZero: true,
                              fontColor: "#d7d9da",
                              callback: function (value, index, values) {
                                return "$" + value;
                              },
                            },
                          },
                        ],
                        xAxes: [
                          {
                            ticks: {
                              fontColor: "#d7d9da",
                            },
                          },
                        ],
                      },
                      legend: {
                        display: false,
                        labels: {
                          // This more specific font property overrides the global property
                          fontColor: "#d7d9da",
                        },
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row px-2">
            <div className="col-12 rounded-lg badge-dark border border-black  py-3">
              <div className="row">
                <div className="col-12 h6">24h Top Markets</div>
              </div>
              <div className="row text-center overflow-hidden">
                <div className="col-3 ">Market</div>
                <div className="col-2 ">Bots</div>
                <div className="col-3 ">Profit ($)</div>
                <div className="col-4 ">Volume ($)</div>
              </div>
              {summery.map((item, key) => {
                if (item.dailyVolume > 0) {
                  return (
                    <div key={key} className="row text-center overflow-hidden">
                      <div
                        className="col-3 overflow-hidden "
                        style={{ fontSize: "0.85rem" }}
                      >
                        {item.market.toUpperCase()}
                      </div>
                      <div className="col-2 ">{item.bots}</div>
                      <div className="col-3 text-right">
                        {parseFloat(item.dailyProfit) >= 0
                          ? item.dailyProfit
                              .toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })
                              .slice(1)
                          : "-" +
                            item.dailyProfit
                              .toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })
                              .slice(2)}
                      </div>
                      <div className="col-4 text-right">
                        {item.dailyVolume
                          .toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })
                          .slice(1)}
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          </div>
          <div className="row my-2 px-2">
            <div className="col-12 rounded-lg badge-dark border border-black   py-3">
              <div className="row">
                <div className="col-12 h6">All Users Data</div>
              </div>
              <div className="row text-left">
                <div className="col-7 " style={{ fontSize: "0.92rem" }}>
                  Last 30 day's Volume :{" "}
                </div>
                <div className="col-5 ">
                  {total.volume.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
                </div>
              </div>{" "}
              {false && (
                <div className="row text-left">
                  <div className="col-7 " style={{ fontSize: "0.92rem" }}>
                    Current Week Volume :{" "}
                  </div>
                  <div className="col-5 ">
                    {total.weeklyVolume &&
                      total.weeklyVolume.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                      })}
                  </div>
                </div>
              )}{" "}
              {false && (
                <div className="row text-left">
                  <div className="col-7 " style={{ fontSize: "0.92rem" }}>
                    Yesterday Volume :{" "}
                  </div>
                  <div className="col-5 ">
                    {total.yesterdayVolume &&
                      total.yesterdayVolume.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                      })}
                  </div>
                </div>
              )}
              <div className="row text-left">
                <div className="col-7 " style={{ fontSize: "0.92rem" }}>
                  24H Volume :{" "}
                </div>
                <div className="col-5 ">
                  {total.volume24H &&
                    total.volume24H.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })}
                </div>
              </div>{" "}
              <div className="row text-left">
                <div className="col-7 " style={{ fontSize: "0.92rem" }}>
                  Today Total Volume :{" "}
                </div>
                <div className="col-5 ">
                  {" "}
                  {total.dailyVolume.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
                </div>
              </div>{" "}
              {false && (
                <div className="row text-left">
                  <div className="col-7 " style={{ fontSize: "0.92rem" }}>
                    Today Total Trades :{" "}
                  </div>
                  <div className="col-5 ">{total.dailyTrades}</div>
                </div>
              )}
              {false && (
                <div className="row text-left">
                  <div className="col-7 " style={{ fontSize: "0.92rem" }}>
                    Today Active Bots :{" "}
                  </div>
                  <div className="col-5 ">{total.bots}</div>
                </div>
              )}
            </div>
          </div>
          {false && (
            <div className="row my-2 px-2">
              <div className="col-12 rounded-lg badge-dark border border-black   py-3">
                <div className="row">
                  <div className="col-12 h6">Nash Exchange Data</div>
                </div>
                <div className="row text-left">
                  <div className="col-7 " style={{ fontSize: "0.92rem" }}>
                    Current Week Volume :{" "}
                  </div>
                  <div className="col-5 ">
                    {exchangeData.weeklyVolume &&
                      (exchangeData.weeklyVolume * 2).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                      })}
                  </div>
                </div>{" "}
                {false && (
                  <div className="row text-left">
                    <div className="col-7 " style={{ fontSize: "0.92rem" }}>
                      Yesterday Volume :{" "}
                    </div>
                    <div className="col-5 ">
                      {exchangeData.yesterdayVolume &&
                        (exchangeData.yesterdayVolume * 2).toLocaleString(
                          "en-US",
                          {
                            style: "currency",
                            currency: "USD",
                          }
                        )}
                    </div>
                  </div>
                )}
                {true && (
                  <div className="row text-left">
                    <div className="col-7 " style={{ fontSize: "0.92rem" }}>
                      24H Volume :{" "}
                    </div>
                    <div className="col-5 ">
                      {exchangeData.volume24H &&
                        (exchangeData.volume24H * 2).toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })}
                    </div>
                  </div>
                )}
                <div className="row text-left">
                  <div className="col-7 " style={{ fontSize: "0.92rem" }}>
                    Today Volume :{" "}
                  </div>
                  <div className="col-5 ">
                    {" "}
                    {exchangeData.todayVolume &&
                      (exchangeData.todayVolume * 2).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                      })}
                  </div>
                </div>{" "}
              </div>
            </div>
          )}{" "}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  volumeNprofitData: state.volumeNprofit.data,
  monthlyProfit: state.volumeNprofit.monthlyProfit,
  monthlyVolume: state.volumeNprofit.monthlyVolume,
  todayProfit: state.volumeNprofit.todayProfit,
  todayVolume: state.volumeNprofit.todayVolume,
  yesterDayVolume: state.volumeNprofit.yesterDayVolume,
  userWeeklydata: state.volumeNprofit.userWeeklydata,
  userWeeklyProfitdata: state.volumeNprofit.userWeeklyProfitdata,
  botsCount: state.botsCount.botsCount,
});

export default connect(mapStateToProps)(Dashboard);
